import React from "react";

export default function BenefitsOfRegistring() {
    return (
        <div className="px-4 sm:px-14 lg:px-24 py-8 text-black text-[32px] leading-tight">
            <h1 className="text-[#03897B] font-bold mb-6">BENEFITS OF REGISTERING AS AN ENTERPRENUR</h1>
            <p className="mb-8 font-normal">
                Registering as an entrepreneur with the Ad-Luck organization can provide several advantages to entrepreneurs emerging and small-scale farmers or agripreneurs. While specific benefits may vary depending on Ad-Luck's programs and services.
            </p>

            <div className="space-y-8">
                {[
                    {
                        title: "1. Access to Training and Capacity Building",
                        points: [
                            "Registered entrepreneurs often gain access to specialized training programs, workshops, and mentorship opportunities.",
                            "These initiatives can enhance skills in areas such as farm management, financial literacy, marketing, and sustainable agricultural practices."
                        ],
                    },
                    {
                        title: "2. Eligibility for Grants and Funding",
                        points: [
                            "Many organizations provide grants, low-interest loans, or seed funding to registered entrepreneurs.",
                            "Being officially registered makes it easier to apply for and receive financial support, which is crucial for business expansion and sustainability."
                        ],
                    },
                    {
                        title: "3. Networking and Market Linkages",
                        points: [
                            "Registration can facilitate connections with other entrepreneurs, cooperatives, buyers, and suppliers.",
                            "These networks can open up new markets, collaborative opportunities, and access to bulk purchasing or selling arrangements."
                        ],
                    },
                    {
                        title: "4. Business Development Support",
                        points: [
                            "Registered entrepreneurs may receive assistance in developing business plans, improving operational efficiency, and navigating regulatory requirements.",
                            "This support is vital for long-term business growth and compliance."
                        ],
                    },
                    {
                        title: "5. Enhanced Credibility and Trust",
                        points: [
                            "Being registered with a reputable organization like Ad-Luck can increase your business's credibility.",
                            "It signals to customers, partners, and investors that your enterprise is legitimate and committed to quality and sustainability."
                        ],
                    },
                    {
                        title: "6. Access to Market Information and Resources",
                        points: [
                            "Organizations often provide registered entrepreneurs with valuable market insights, access to agricultural inputs, and information on best practices.",
                            "This can lead to improved productivity and competitiveness."
                        ],
                    },
                    {
                        title: "7. Advocacy and Representation",
                        points: [
                            "Registered entrepreneurs may benefit from advocacy efforts aimed at influencing agricultural policies and securing better support for small-scale farmers.",
                            "Being part of a registered network can amplify your voice in policy discussions."
                        ],
                    },
                ].map((item, idx) => (
                    <div key={idx}>
                        <p className="font-semibold mb-2">{item.title}</p>
                        <ul className="list-disc pl-5 space-y-2">
                            {item.points.map((point, i) => (
                                <li key={i}>{point}</li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <style jsx>{`
                @media (max-width: 640px) {
                    div {
                        font-size: 8px;
                    }
                }
            `}</style>
        </div>
    );
}
